import { render, staticRenderFns } from "./MyWallet.vue?vue&type=template&id=24940279&scoped=true&"
import script from "./MyWallet.vue?vue&type=script&lang=js&"
export * from "./MyWallet.vue?vue&type=script&lang=js&"
import style0 from "./MyWallet.vue?vue&type=style&index=0&id=24940279&prod&lang=less&scoped=true&"
import style1 from "./MyWallet.vue?vue&type=style&index=1&id=24940279&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24940279",
  null
  
)

export default component.exports